"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UISettingsTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SecondaryNavigation = require("../secondary-navigation/SecondaryNavigation");
var _SettingsContext = require("../../context/settings/SettingsContext");
var UISettingsTabs = function UISettingsTabs(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    categories = _ref.categories;
  var _useSettings = (0, _SettingsContext.useSettings)(),
    settings = _useSettings.settings,
    uiSettings = _useSettings.uiSettings;
  var visibleCategories = (0, _react.useMemo)(function () {
    return categories.filter(function (category) {
      var _settings$angularUISe, _settings$angularUISe2, _settings$angularUISe3;
      if (category.usesNewSettings) {
        var _uiSettings$pages$fin, _uiSettings$pages$fin2;
        return (_uiSettings$pages$fin = uiSettings === null || uiSettings === void 0 ? void 0 : (_uiSettings$pages$fin2 = uiSettings.pages.find(function (page) {
          return page.id === category.pageId;
        })) === null || _uiSettings$pages$fin2 === void 0 ? void 0 : _uiSettings$pages$fin2.visible) !== null && _uiSettings$pages$fin !== void 0 ? _uiSettings$pages$fin : false;
      }
      var pageSettingDefined = settings === null || settings === void 0 ? void 0 : (_settings$angularUISe = settings.angularUISettings) === null || _settings$angularUISe === void 0 ? void 0 : (_settings$angularUISe2 = _settings$angularUISe.pages) === null || _settings$angularUISe2 === void 0 ? void 0 : (_settings$angularUISe3 = _settings$angularUISe2[category.pageId]) === null || _settings$angularUISe3 === void 0 ? void 0 : _settings$angularUISe3.shouldDisplayForCurrentUser;
      return pageSettingDefined !== null && pageSettingDefined !== void 0 ? pageSettingDefined : true;
    });
  }, [categories, settings, uiSettings]);
  return /*#__PURE__*/_react.default.createElement(_SecondaryNavigation.SecondaryNavigation, {
    className: className,
    icon: icon,
    categories: visibleCategories
  });
};
exports.UISettingsTabs = UISettingsTabs;